import React from "react";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "../mock";

const Testimonials = () => {
  return (
    <section id="reviews" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-sm font-semibold uppercase tracking-wider text-[#DC2626]">
            What people built
          </span>
          <h2 className="font-display mt-3 text-4xl sm:text-5xl font-700 tracking-tight text-[#0A2540]">
            Loved by North American builders
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <div
              key={i}
              className="relative rounded-2xl border border-slate-200 bg-white p-7 hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
            >
              <Quote className="h-8 w-8 text-blue-100" />
              <div className="mt-3 flex gap-0.5">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} className="h-4 w-4 fill-[#DC2626] text-[#DC2626]" />
                ))}
              </div>
              <p className="mt-4 text-slate-700 leading-relaxed">“{t.quote}”</p>
              <div className="mt-6 flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#1D4ED8] text-white font-semibold">
                  {t.name.charAt(0)}
                </span>
                <div>
                  <div className="font-semibold text-[#0A2540]">{t.name}</div>
                  <div className="text-sm text-slate-500">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
